/**
 * Formatação do relatório de abordagem em PDF.
 *
 * O fuso é FIXO em America/Sao_Paulo, e não o do navegador: as colunas de data
 * são `timestamp with time zone`, então o instante está certo no banco e quem
 * decide como mostrar é o documento. A tela antiga fazia `zonedTimeToUtc` e
 * acertava só porque o deslocamento se anulava com o fuso da máquina — num
 * navegador fora do horário de Brasília o horário impresso sairia errado.
 */

const TRAVESSAO = '—';
const FUSO = 'America/Sao_Paulo';

const partes = (iso, opcoes) => {
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return null;
  return new Intl.DateTimeFormat('pt-BR', { timeZone: FUSO, ...opcoes })
    .formatToParts(data)
    .reduce((acumulado, parte) => ({ ...acumulado, [parte.type]: parte.value }), {});
};

export const dataHora = iso => {
  if (!iso) return TRAVESSAO;
  const p = partes(iso, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return p ? `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}` : TRAVESSAO;
};

/**
 * Data pura (validade de CNH): formatada em UTC de propósito.
 *
 * A coluna é `timestamp with time zone` mas guarda meia-noite UTC — é uma data,
 * não um instante. Convertê-la para America/Sao_Paulo joga o valor para as 21h
 * do DIA ANTERIOR, que é o que a tela antiga imprime hoje (uma CNH que vence em
 * 14/03 aparece como 13/03).
 */
export const dataCurta = iso => {
  if (!iso) return TRAVESSAO;
  const p = partes(iso, { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' });
  return p ? `${p.day}/${p.month}/${p.year}` : TRAVESSAO;
};

export const quantidade = valor =>
  new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 3 }).format(Number(valor || 0));

export const dinheiro = valor =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
    .format(Number(valor || 0))
    // o Intl usa espaço não separável entre "R$" e o número; nos comparadores
    // (e na busca dentro do PDF) o espaço comum é o que se espera.
    .replace(/ /g, ' ');

export const nomeAgente = usuario => {
  if (!usuario) return TRAVESSAO;
  const civil = [usuario.nome, usuario.sobrenome].filter(Boolean).join(' ').trim();
  return usuario.nome_social || civil || TRAVESSAO;
};

export const quantidadeDoItem = item => {
  const unidade = (item.unidade_medida && item.unidade_medida.nome) || '';
  if (unidade === 'R$') return dinheiro(item.quantidade);
  return `${quantidade(item.quantidade)} ${unidade}`.trim();
};
